import * as React from "react";
import * as React44ms from "../../Util/form-utils/react-44ms";

import {
  useDeliveryDetailsFormRef_asController,
  useMyBagOnThisPage,
} from "../providers";

import { DeliveryDetails } from "../delivery-details";

import { MyBagSummary } from "../my-bag-summary";
import { ReactCheckout2022_AllTheForms } from "../all-the-forms";

export const PageDeliveryDetails: React.FunctionComponent = () => {
  useMyBagOnThisPage();

  const { setDeliveryDetailsFormRef } =
    useDeliveryDetailsFormRef_asController();

  const [_formState, locate] =
    React44ms.React.useForm<ReactCheckout2022_AllTheForms>();

  React.useEffect(() => {
    setDeliveryDetailsFormRef(locate.deliveryDetails.typedRef);
    return () => {
      setDeliveryDetailsFormRef(null);
    };
  }, [locate.deliveryDetails.typedRef, setDeliveryDetailsFormRef]);

  return (
    <section className="main-content delivery-details">
      <section className="main">
        <DeliveryDetails formRef={locate.deliveryDetails.typedRef} />
      </section>
      <section className="side">
        <MyBagSummary hideActions hideGiftcardNotice />
      </section>
    </section>
  );
};
